// ============================================
// salon/routes/SalonRoutes.js
// Dedicated Salon Sub-Router
// ============================================

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../../common/context/AuthContext';
import PrivateRoute from '../../common/routes/PrivateRoute';

// Auth Components
import SalonSignIn from '../auth/SalonSignIn';
import SalonSignUp from '../auth/SalonSignUp';
import SalonForgotPassword from '../auth/SalonForgotPassword';

// Layout & Permission Guards
import SalonLayout from '../components/SalonLayout';
import SalonProtectedRoute from '../permissions/SalonProtectedRoute';
import SalonPermissionRoute from '../permissions/SalonPermissionRoute';

// Pages
import SalonDashboard from '../pages/SalonDashboard';
import SalonServices from '../pages/SalonServices';
import SalonProducts from '../pages/SalonProducts';
import SalonExpenses from '../pages/SalonExpenses';
import SalonStaff from '../pages/SalonStaff';
import SalonBilling from '../pages/SalonBilling';
import SalonBillHistory from '../pages/SalonBillHistory';
import SalonSettings from '../settings/SalonSettings';
import SalonMarketing from '../pages/SalonMarketing';
import SalonMemberships from '../pages/SalonMemberships';
import SalonLeads from '../pages/SalonLeads';

// Reports
import SalonSalesReport from '../reports/SalonSalesReport';
import SalonExpenseReport from '../reports/SalonExpenseReport';
import SalonAttendantReport from '../reports/SalonAttendantReport';

export default function SalonRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      {/* Salon Auth */}
      <Route path="/signup" element={!isAuthenticated ? <SalonSignUp /> : <Navigate to="/salon/dashboard" />} />
      <Route path="/signin" element={!isAuthenticated ? <SalonSignIn /> : <Navigate to="/salon/dashboard" />} />
      <Route path="/forgot-password" element={<SalonForgotPassword />} />

      {/* Salon Operations (Wrapped in SalonLayout) */}
      <Route path="/dashboard" element={<PrivateRoute><SalonLayout><SalonPermissionRoute permission="dashboard.view"><SalonDashboard /></SalonPermissionRoute></SalonLayout></PrivateRoute>} />
      <Route path="/billing" element={<PrivateRoute><SalonLayout hideHeader noPadding><SalonPermissionRoute permission="billing.view"><SalonBilling /></SalonPermissionRoute></SalonLayout></PrivateRoute>} />
      <Route path="/services" element={<PrivateRoute><SalonLayout><SalonPermissionRoute permission="services.view"><SalonServices /></SalonPermissionRoute></SalonLayout></PrivateRoute>} />
      <Route path="/products" element={<PrivateRoute><SalonLayout><SalonPermissionRoute permission="products.view"><SalonProducts /></SalonPermissionRoute></SalonLayout></PrivateRoute>} />
      <Route path="/memberships" element={<PrivateRoute><SalonLayout><SalonPermissionRoute permission="memberships.view"><SalonMemberships /></SalonPermissionRoute></SalonLayout></PrivateRoute>} />
      <Route path="/expenses" element={<PrivateRoute><SalonLayout><SalonPermissionRoute permission="expenses.view"><SalonExpenses /></SalonPermissionRoute></SalonLayout></PrivateRoute>} />
      <Route path="/leads" element={<PrivateRoute><SalonLayout><SalonPermissionRoute permission="leads.view"><SalonLeads /></SalonPermissionRoute></SalonLayout></PrivateRoute>} />
      <Route path="/staff" element={<PrivateRoute><SalonLayout><SalonPermissionRoute permission="staff.view"><SalonStaff /></SalonPermissionRoute></SalonLayout></PrivateRoute>} />
      <Route path="/bill-history" element={<PrivateRoute><SalonLayout><SalonPermissionRoute permission="bill_history.view"><SalonBillHistory /></SalonPermissionRoute></SalonLayout></PrivateRoute>} />
      <Route path="/marketing" element={<PrivateRoute><SalonLayout><SalonPermissionRoute permission="marketing.view"><SalonMarketing /></SalonPermissionRoute></SalonLayout></PrivateRoute>} />
      <Route path="/settings" element={<PrivateRoute><SalonLayout><SalonPermissionRoute permission="settings.view"><SalonSettings /></SalonPermissionRoute></SalonLayout></PrivateRoute>} />

      {/* Reports (Protected with PIN lock) */}
      <Route path="/sales-report" element={<PrivateRoute><SalonLayout><SalonPermissionRoute permission="reports.view"><SalonProtectedRoute reportKey="sales"><SalonSalesReport /></SalonProtectedRoute></SalonPermissionRoute></SalonLayout></PrivateRoute>} />
      <Route path="/expense-report" element={<PrivateRoute><SalonLayout><SalonPermissionRoute permission="reports.view"><SalonProtectedRoute reportKey="expenses"><SalonExpenseReport /></SalonProtectedRoute></SalonPermissionRoute></SalonLayout></PrivateRoute>} />
      <Route path="/attendant-report" element={<PrivateRoute><SalonLayout><SalonPermissionRoute permission="reports.view"><SalonProtectedRoute reportKey="attendant"><SalonAttendantReport /></SalonProtectedRoute></SalonPermissionRoute></SalonLayout></PrivateRoute>} />
    </Routes>
  );
}
